module.exports = __webpack_public_path__ + "img/pikachu.fe61dc2b.gif";